<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 15:52:30
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-03 16:44:36
 * @Description: Tab
 -->
<template>
  <div class="mid-tab-wrapper">
    <div class="tab-box">
      <ul class="tab">
        <li
          class="tab-item"
          @mouseover="handleTab(index)"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: activeIndex === index }"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="tab-content-box">
      <ul class="tab-content">
        <li class="img-item" :class="{ active: activeIndex === 0 }">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-01.png" alt="" srcset="" />
          <div class="text">
            <h3>大数据风控</h3>
            <div class="line"></div>
            <p>
              鲸鱼接入了丰富的数据源，构造多种变量，并建立了基于深度学习的风控模型，实现了高效、准确的信贷风险评估
            </p>
          </div>
        </li>
        <li class="img-item" :class="{ active: activeIndex === 1 }">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-02.png" alt="" srcset="" />
          <div class="text">
            <h3>小额分散</h3>
            <div class="line"></div>
            <p>
              小额分散的投资方式有效的分散了投资风险，保护投资者的权益，全方位为社会所有阶层和群体提供普惠金融服务
            </p>
          </div>
        </li>
        <li class="img-item" :class="{ active: activeIndex === 2 }">
          <img src="https://files.jinr.com/jinr-index/img/mid-tab-03.png" alt="" srcset="" />
          <div class="text">
            <h3>资产多元化</h3>
            <div class="line"></div>
            <p>鲸鱼致力于接入信用评级高的消费信贷、车辆抵押贷款，多种资产方式防止系统性风险</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mid-tab',
  data() {
    return {
      tabList: [
        {
          label: '大数据风控'
        },
        {
          label: '小额分散'
        },
        {
          label: '资产多元化'
        }
      ],
      activeIndex: 0
    };
  },
  methods: {
    handleTab(index) {
      this.activeIndex = index;
    }
  }
};
</script>
<style lang="less">
.mid-tab-wrapper {
  background: #202a42;
  .tab-box {
    // background: #212940;
    .tab {
      display: flex;
      width: 1200px;
      height: 138px;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      border-bottom: 2px solid #3f4863;
      .tab-item {
        width: 170px;
        height: 56px;
        position: relative;
        color: #fff;
        font-family: 'PingFangSC-Medium';
        font-size: 18px;
        text-align: center;
        line-height: 56px;
        // background: #212940;
        cursor: pointer;
        transition: all 1s linear;
      }
      .active {
        background: linear-gradient(to right, #1f2942 0%, #2c6fff77 100%);
        &::after {
          content: '';
          display: block;
          position: absolute;
          bottom: -42px;
          left: 0;
          width: 100%;
          height: 4px;
          background: #2c6eff;
        }
      }
    }
  }
  .tab-content-box {
    height: 496px;
    overflow: hidden;
    .img-item {
      width: 1200px;
      position: relative;
      display: none;
      margin: 0 auto;
      .text {
        width: 424px;
        position: absolute;
        left: 80px;
        top: 108px;
        z-index: 2;
        h3 {
          font-family: 'PingFangSC-Medium';
          font-size: 24px;
          color: #dde4f5;
        }
        .line {
          width: 48px;
          height: 6px;
          background: #d8d8d8;
          margin: 20px 0 54px;
        }
        p {
          font-family: 'PingFangSC-Regular';
          font-size: 18px;
          color: #ffffff;
          text-indent: 2em;
        }
      }
    }
    img {
      display: block;
      margin-left: -30%;
    }
    .img-item.active {
      display: block;
      animation: move-in 0.5s;
    }
  }
}
.move-enter-active {
  animation: move-in 0.5s;
}
@keyframes move-in {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>
